import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No staking backend exists in this
// environment: reward accrual, claim, and reconciliation totals were previously
// fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryStakingRewardsPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Staking Positions", href: "/treasury/staking" }], label: "Rewards & Accounting" }}
      state={{
        title: "Rewards & Accounting is not available in this environment yet",
        description: "Staking reward accrual, claims, and reconciliation status have no backend in this environment yet. This page will show real reward data once the staking domain is built.",
      }}
    />
  );
}
